<template>
  <div class="container">
    <wrap-container>
      <p id="titulo" class="step-title" v-html="config.pasos.paso1.titulo"></p>
    </wrap-container>
    <wrap-container class="grid-container grid-container--6-6">
      <wrap-container class="col1 form">
        <p v-html="config.pasos.paso1.subtitulo" style="margin-bottom: 0px" />
        <p v-html="config.pasos.paso1.subtitulo2" style="margin-top: 0px" />
        <form-validator>
          <wrap-container class="grid-container grid-container--6-6">
            <text-input-custom
              class="col1"
              label="Nombre"
              name="nombre"
              hint="Ingresá tu nombre"
              maxlength="50"
              v-model="model.nombre"
              :required="true"
              @focus="trackClick('nombre')"
            />

            <text-input-custom
              class="col2"
              label="Apellido"
              name="apellido"
              hint="Ingresá tu apellido"
              v-model="model.apellido"
              maxlength="50"
              :required="true"
              @focus="trackClick('apellido')"
            />
          </wrap-container>

          <wrap-container class="form__document">
            <document-number class="form__block" v-model="model.documento" />
          </wrap-container>

          <wrap-container class="form__email">
            <email-field
              v-model="model.email"
              maxlength="50"
              :required="true"
              name="email"
              @focus="trackClick('email')"
            />
          </wrap-container>

          <wrap-container class="form__phone">
            <phone-number class="form__block" v-model="model.celular" />
          </wrap-container>

          <wrap-container class="form__terms">
            <terms-wrapper />
          </wrap-container>

          <div class="relative-container espaciadoFinal">
            <step-navigator v-model="model" :store-action="this.doNext" />
          </div>
        </form-validator>
      </wrap-container>
      <wrap-container class="col2 form">
        <img src="@/assets/img/gift.png" class="gift" alt="" />
      </wrap-container>
    </wrap-container>

    <wrap-container>
      <re-captcha />
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import TextInputCustom from "@/components/core/TextInputCustom";
import PhoneNumber from "@/components/core/composite/combos/PhoneNumber";
import EmailField from "@/components/core/EmailField";
import { DO_ADOBE_APPSTARTED } from "@/config/constants/action-types";
import { DO_LANDING } from "@/config/constants/action-types";
import TermsWrapper from "@/components/core/TermsWrapper";
import StepNavigator from "@/components/core/StepNavigator";
import DocumentNumber from "@/components/core/composite/combos/DocumentNumber";
import ReCaptcha from "@/components/core/ReCaptcha";

export default {
  name: "Paso1",
  data() {
    return {
      model: this.$store.getters.getPaso1(),
      doNext: DO_LANDING
    };
  },
  props: {
    myObject: {
      userName: String
    }
  },
  components: {
    TextInputCustom,
    PhoneNumber,
    EmailField,
    FormValidator,
    WrapContainer,
    TermsWrapper,
    DocumentNumber,
    StepNavigator,
    ReCaptcha
  },
  methods: {
    trackClick(el) {
      /**
       * Hacer un dispatch del evento click sobre un elemento
       * para trackear analítica
       */
      this.$store.dispatch(DO_ADOBE_APPSTARTED, el);
    }
  }
};
</script>

<style scoped>
.benefit__title {
  font-family: BentonSansBBVA-Book;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #121212;
  position: relative;
  margin: 0 0 30px 0;
}

.form {
  max-width: 556px;
}

.form__name {
  margin-bottom: 8px;
}

.form__name div.container {
  margin-bottom: 0;
}

.form__email {
  margin-bottom: 32px;
}

.form__next {
  margin-top: 42px;
}

.benefit {
  margin: 0 0 48px 10px;
  max-width: 420px;
}

.benefit__item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.benefit__item p {
  margin: 0;
}

.benefit__icon {
  width: 32px;
  height: 32px;
  margin-right: 16px;
}

.benefit__label {
  padding-left: 50px;
}

.gift {
  width: 15%;
  left: 50%;
  top: 30%;
  position: absolute;
}

@media screen and (max-width: 900px) {
  .form__block {
    display: block;
  }
  .benefit__title {
    font-size: 18px;
  }
  .benefit {
    margin-left: 0;
  }
}
</style>
